import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
// import { getOpenId, getToken, removeToken } from '@/utils/auth';
// import { WEBSITE_TITLE } from '@/config';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/center',
    name: 'Center',
    component: Home,
    meta: {
      title: '江苏环境保护产业协会会员单位查询系统',
    },
  },
  {
    path: '/manage',
    name: 'Manage',
    component: () => import('@/views/Manage.vue'),
    meta: {
      title: '环境污染治理能力评价证书查询系统',
    },
  },
  {
    path: '/sewage',
    name: 'Sewage',
    component: () => import('@/views/Sewage.vue'),
    meta: {
      title: '污染治理设施运行服务能力评价证书查询系统',
    },
  },
  {
    path: '/overall',
    name: 'Overall',
    component: () => import('@/views/Overall.vue'),
    meta: {
      title: '环境污染治理工程总承包能力评价证书查询系统',
    },
  },
  {
    path: '/sewage',
    name: 'Sewage',
    component: () => import('@/views/Sewage.vue'),
    meta: {
      title: '污染治理设施运行服务能力评价证书查询系统',
    },
  },
  {
    path: '/design',
    name: 'Design',
    component: () => import('@/views/Design.vue'),
    meta: {
      title: '环境污染治理工程设计能力评价证书查询系统',
    },
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: {
      title: '环保检测中心',
    },
  },
  {
    path: '/content',
    name: 'Content',
    component: () => import('@/views/Content.vue'),
    meta: {
      title: '环保检测中心',
    },
  },
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  next();
});
export default router;
